<template>
  <el-row
    v-if="resolvedConfig && !resolvedConfig.__responsiveHidden"
    :gutter="resolvedConfig.gutter"
    :justify="resolvedConfig.justifyContent"
    :align="resolvedConfig.alignItems"
    :style="rowStyle"
    type="flex"
    class="row-wrap"
  >
    <Col
      v-if="resolvedConfig.children && resolvedConfig.children.length"
      v-for="(item, colIdx) in resolvedConfig.children"
      :key="colIdx"
      :currentElementIndex="currentElementIndex"
      :allArcListMap="allArcListMap"
      :idx="colIdx"
      :listLength="resolvedConfig.children.length"
      :parentKeys="[...parentKeys, idx]"
      :disabled="disabled"
      :config="item.config"
    ></Col>
    <ClickConfigOverlay
      v-if="hasMeaningfulClickConfig(resolvedConfig.clickConfig)"
      :config="resolvedConfig.clickConfig"
    />
  </el-row>
</template>

<script setup>
import { computed } from 'vue';
import Col from './Col.vue';
import ClickConfigOverlay from './common/ClickConfigOverlay.vue';
import { useResponsiveConfig } from './uses/useResponsiveConfig.js';

const props = defineProps({
  allArcListMap: { type: Object, default: () => ({}) },
  currentElementIndex: { type: Array, default: () => [] },
  idx: { type: Number, default: -1 },
  parentKeys: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: true },
  config: { type: Object },
});

const { resolvedConfig } = useResponsiveConfig(() => props.config || {});

const hasMeaningfulClickConfig = (config) => {
  if (!config || !config.responseType) {
    return false;
  }
  if (config.responseType === 'link' || config.responseType === 'jumpLink') {
    return !!config.link;
  }
  if (config.responseType === 'popup') {
    return !!config.article || !!config.popupTitle || !!config.popupClass;
  }
  if (config.responseType === 'popoverPage') {
    return (
      !!config.popoverPageId ||
      !!config.popoverPageTitle ||
      !!config.popoverPageData
    );
  }
  return true;
};

const rowStyle = computed(() => {
  const config = resolvedConfig.value || props.config || {};
  return {
    flexWrap: config.isNoWrap ? 'nowrap' : config.flexWrap || 'wrap',
    flexDirection: config.flexDirection || undefined,
    display: config.display || 'flex',
    justifyContent: config.justifyContent || undefined,
    alignItems: config.alignItems || undefined,
    gap:
      typeof config.gap === 'number' ? `${config.gap}px` : undefined,
  };
});
</script>

<style scoped>
.row-wrap {
  position: relative;
  background-size: 100% auto;
  background-position: center top;
  width: 100%;
  height: 100%;
}
</style>
